import React from 'react';
import Navigation from '@/common/navigation/index';

export const Layout = ({ steps, children }) => {
    return (
        <div className="main-wrapper">
            <Navigation steps={steps} />
            <div className="flexbox-parent">
                <div className="fill-area">
                    <div className="content">
                        {children}
                    </div>
                </div>
            </div>
        </div>);
}
